
// const API_base_URL = "http://localhost/flexionlinebuchung";
const API_base_URL = "https://flexi-stwsiegen.de/flexionlinebuchung";


export const API_endpoints = {

    //worktime and holyday

    WorkTimeSlots: `${API_base_URL}/work-time/work-time-slots.php`,
    HolidaySlots: `${API_base_URL}/work-time/holiday-slots.php`,
    closeWorkDay: `${API_base_URL}/work-time/close-work-day.php`,
    openWorkDay: `${API_base_URL}/work-time/open-work-day.php`,
    deleteWorkBlock: `${API_base_URL}/work-time/delete-work-block.php`,
    addWorkBlock: `${API_base_URL}/work-time/add-work-block.php`,
    setHolyday: `${API_base_URL}/work-time/set-holiday.php`,
    getBlockData: `${API_base_URL}/work-time/get-block-name.php`,
    getFutureHolydays: `${API_base_URL}/work-time/get-future-holydays.php`,
    deleteHolyday: `${API_base_URL}/work-time/delete-holyday.php`,

    //profiles
    getProfileInfo: `${API_base_URL}/profile-mamagment/get-profile-info.php`,
    setProfileInfo: `${API_base_URL}/profile-mamagment/set-profile-info.php`,
    setKidProfile: `${API_base_URL}/profile-mamagment/set-kid-profile.php`,
    setProfileArchived: `${API_base_URL}/profile-mamagment/set-profile-archived.php`,
    setKidArchived: `${API_base_URL}/profile-mamagment/set-kid-archived.php`,
    setKidDearchived: `${API_base_URL}/profile-mamagment/set-kid-dearchived.php`,
    updateKidProfile: `${API_base_URL}/profile-mamagment/update-kid-profile.php`,
    setProfileDearchived: `${API_base_URL}/profile-mamagment/set-profile-dearchived.php`,
    getParentData: `${API_base_URL}/profile-mamagment/get-parent-data.php`,
    searchKids: `${API_base_URL}/profile-mamagment/search-kids.php`,
    getKidContact: `${API_base_URL}/profile-mamagment/get-kid-contact.php`,
    getProfileStatusChanges: `${API_base_URL}/profile-mamagment/get-profile-status-changes.php`,

    //Booking

    setsBooking: `${API_base_URL}/booking/set-booking.php`,
    setsEmployBooking: `${API_base_URL}/booking/set-employ-booking.php`,
    getParentsKidBooking: `${API_base_URL}/booking/get-parents-kid-bookings.php`,
    getintervalBookingsemploy: `${API_base_URL}/booking/get-interval-bookings-employ.php`,
    getallBookingsList: `${API_base_URL}/booking/get-all-bookings-list.php`,
    processBooking: `${API_base_URL}/booking/process-booking.php`,
    setBookingCancel: `${API_base_URL}/booking/set-booking-cancel.php`,
    deleteBooking: `${API_base_URL}/booking/delete-booking.php`,
    getBlockBookingsEmploy: `${API_base_URL}/booking/get-block-bookings-employ.php`,
    getSlotBookingDateCounter: `${API_base_URL}/booking/get-slot-booking-date-counter.php`,
    getParentBookingCounter: `${API_base_URL}/booking/get-parent-booking-counter.php`,
    getEmployBookingCounter: `${API_base_URL}/booking/get-employ-booking-counter.php`,
    setBookingUnregistered: `${API_base_URL}/booking/set-booking-unregistered.php`,

    //Login

    EmailCheck: `${API_base_URL}/login/check-email.php`,
    rigisteSubmit: `${API_base_URL}/login/register.php`,
    loginSubmit: `${API_base_URL}/login/login.php`,
    logout: `${API_base_URL}/login/logout.php`,
    setEmployPassword: `${API_base_URL}/login/employ-set-password.php`,
    resetPasswordRequest: `${API_base_URL}/login/reset-password-request.php`,
    updatePassword: `${API_base_URL}/login/update-password.php`,

    //Session

    checkSession: `${API_base_URL}/check-session.php`,
    getParentsKids: `${API_base_URL}/get-parents-kids.php`,
    getallKids: `${API_base_URL}/get-all-kids.php`,
    getAllParent: `${API_base_URL}/get-all-parent.php`,

    //cost

    getCost: `${API_base_URL}/cost/get-cost.php`,
    updateCost: `${API_base_URL}/cost/update-cost.php`,
    deleteCost: `${API_base_URL}/cost/delete-cost.php`,
    setCost: `${API_base_URL}/cost/set-cost.php`,

    //FAQ

    getFAQs: `${API_base_URL}/FAQ/get-FAQs.php`,
    updateFAQs: `${API_base_URL}/FAQ/update-FAQ.php`,
    deleteFAQs: `${API_base_URL}/FAQ/delete-FAQ.php`,
    setFAQs: `${API_base_URL}/FAQ/set-FAQ.php`,

    //Employ

    getEmploy: `${API_base_URL}/employManagment/get-employ.php`,
    updateEmploy: `${API_base_URL}/employManagment/update-employ.php`,
    deleteEmploy: `${API_base_URL}/employManagment/delete-employ.php`,
    setEmploy: `${API_base_URL}/employManagment/set-employ.php`,

    //Statistic

    statistic1: `${API_base_URL}/statistic/statistik1.php`,
    statistic2: `${API_base_URL}/statistic/statistik2.php`,
    statistic3: `${API_base_URL}/statistic/statistik3.php`,
    statistic4: `${API_base_URL}/statistic/statistik4.php`,
    statistic5: `${API_base_URL}/statistic/statistik5.php`,
    statistic6: `${API_base_URL}/statistic/statistik6.php`,
    statistic7: `${API_base_URL}/statistic/statistik7.php`,
    statistic8: `${API_base_URL}/statistic/statistik8.php`,
    statistic9: `${API_base_URL}/statistic/statistik9.php`,
    statistic10: `${API_base_URL}/statistic/statistik10.php`,
};
